'use client';

/**
 * POST a Firebase ID token to `/auth/session`, which mints (or renews) the
 * httpOnly `__session` cookie for server-side auth. Returns whether the
 * request succeeded.
 *
 * Deliberately Firebase-free: it takes an already-resolved `idToken` rather
 * than reading `auth().currentUser`, so callers that must keep `firebase/auth`
 * off their first-load bundle (the visitor bio's deferred session warmer) can
 * use it without dragging the SDK into their static import graph.
 */
export async function postSessionCookie(idToken: string): Promise<boolean> {
  const response = await fetch('/auth/session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ idToken }),
    credentials: 'include',
  });
  return response.ok;
}
